import { USAGE_ANALYTICS_COPY } from '../copy';

/**
 * ─────────────────────────────────────────────────────────────────────────────────
 *  WHAT THIS PAGE CANNOT SHOW — ALWAYS RENDERED, AS PLAIN TEXT. [ANALYTICS §5]
 *
 *  ⚠️ OUTSIDE EVERY LOADING, FAILURE AND ERROR BRANCH. The limits are true of the page whatever
 *  the report did, and the moment they matter most is when a number looks surprising — which is
 *  also when a section may have failed. A caveat that disappears with its data is not a caveat.
 *
 *  ⚠️ NEVER A TOOLTIP OR A DISCLOSURE. Hover is unavailable on touch and unreachable from a
 *  keyboard, and a caveat an operator must open to find is one they will not find.
 * ─────────────────────────────────────────────────────────────────────────────────
 */
export const LimitsNotice = () => (
  <section
    aria-labelledby="analytics-limits"
    data-testid="analytics-limits"
    className="flex flex-col gap-3 rounded-lg border border-border bg-card p-5"
  >
    <h2 id="analytics-limits" className="text-base font-medium text-heading">
      {USAGE_ANALYTICS_COPY.limits.title}
    </h2>
    <ul className="flex list-disc flex-col gap-1.5 pl-5 text-sm text-muted-foreground">
      {USAGE_ANALYTICS_COPY.limits.sentences.map((sentence) => (
        <li key={sentence}>{sentence}</li>
      ))}
    </ul>
  </section>
);
